import React from 'react';
import { ArrowLong } from '../../assets/img/svg/icons';

interface HeaderProps {
    text: string;
    link: string;
    arrow: boolean;
    color: string;  
    target?: string;
}

const Button: React.FC<HeaderProps> = ({ link, text, arrow, color, target }) => {
    return (
        <a href={link} title={text} className={`rounded-full text-center gap-3 inline-flex justify-center items-center p-4 uppercase text-sm font-semibold transition-all duration-200 w-full hover:bg-main-yellow text-white bg-main-${color && color}`} target={target}>
            {text}
            {arrow && <ArrowLong />}
        </a>
    );
};

export default Button;